import Factset from 'components/shared/Factset/Factset';
import React, { Fragment } from 'react';
import {
  displayIIFooter,
  IIComponentsFooterEnabled
} from 'services/FeatureFlags';
import Footer, { BrokerageCopy } from './Footer';
import {
  FooterBeacon,
  FooterContainer
} from '@trp-ii-ii-component-library/ii-components';
import {compose} from "redux";
import {connect} from "react-redux";
import { getHasOwnedCollegeSavingsOnly } from 'state/account/AccountSelectors';

const AAMFooterContainer = ({
  appLoaded,
  footerProductTypes,
  isMobileParam,
  has529Only,
  showOldFooter = false
}) => {
  return isMobileParam ? <></> : (
    <div className="hide-nav-print">
      {displayIIFooter() ?
        has529Only || showOldFooter ?
          (
            <FooterContainer
              isLoading={!appLoaded}
              productTypes={footerProductTypes}
              applicationData={appLoaded}
              isMobileParam={isMobileParam}
            />
          )
          : (
        <FooterBeacon
          isLoading={!appLoaded}
          productTypes={footerProductTypes}
          applicationData={appLoaded}
          isMobileParam={isMobileParam}
        />
      ) : (
        <Footer />
      )}
    </div>
  );
};

export const FactsetContainer = ({ onAccountsPage, has529Only }) => (
  <Fragment>
    {IIComponentsFooterEnabled() && onAccountsPage && !has529Only && (
      <div className="factset-component-container">
        <Factset />
      </div>
    )}
  </Fragment>
);

export const BrokerageFootnote = ({ isDashboardOrAccounts, hasBrokerage }) => (
  <div className="brokerage-footnote">
    {IIComponentsFooterEnabled() && isDashboardOrAccounts && hasBrokerage && (
      <BrokerageCopy />
    )}
  </div>
);

const mapStateToProps = (state) => ({
  has529Only: getHasOwnedCollegeSavingsOnly(state)
});

export default compose(connect(mapStateToProps))(AAMFooterContainer);